import axios from 'axios'

// En dev : proxy Vite vers localhost:3001. En prod : même domaine.
export const employeeApi = axios.create({ baseURL: `${import.meta.env.VITE_API_URL || ''}/api` })

employeeApi.interceptors.request.use(cfg => {
  const token = localStorage.getItem('employeeToken')
  if (token) cfg.headers.Authorization = `Bearer ${token}`
  return cfg
})

export function getEmployeeToken() {
  return localStorage.getItem('employeeToken')
}

export function setEmployeeToken(token: string) {
  localStorage.setItem('employeeToken', token)
}

export function clearEmployeeToken() {
  localStorage.removeItem('employeeToken')
  localStorage.removeItem('employeeData')
}

export function getEmployeeData() {
  const raw = localStorage.getItem('employeeData')
  return raw ? JSON.parse(raw) : null
}

export function setEmployeeData(data: any) {
  localStorage.setItem('employeeData', JSON.stringify(data))
}
